import { render, staticRenderFns } from "./PrintBuktiPendaftaran.vue?vue&type=template&id=6fa03168"
import script from "./PrintBuktiPendaftaran.vue?vue&type=script&lang=js"
export * from "./PrintBuktiPendaftaran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports